"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const form_1 = require("../modules/form");
const selectors_1 = require("../modules/selectors");
class DynamicButton extends react_1.Component {
    handleClick = passData => {
        const { onClick, ...props } = this.props;
        return onClick(props, passData);
    };
    render() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { component, onClick, ...remProps } = this.props;
        const props = {
            ...remProps,
            handleClick: this.handleClick,
        };
        return react_1.default.createElement(component, props);
    }
}
const mapState = (state, props) => ({
    submitPayload: (0, selectors_1.submissionSelector)(state, props),
});
const mapDispatch = (dispatch, { type, dispatch: payloads = [], submission }) => ({
    onClick: ({ isReadOnly, submitPayload, dispatchers, formId, repeatIndex }, passData) => {
        if (isReadOnly)
            return Promise.resolve();
        if (type === 'submit') {
            if (submission && !submitPayload) {
                throw new Error(`No submission payload found for ${submission}`);
            }
            return dispatch((0, form_1.submitClick)({
                submission,
                submitPayload,
                dispatchers,
                formId,
                repeatIndex,
            }, passData));
        }
        return Promise.all(payloads.map(payload => dispatch((0, form_1.buttonClick)({ payload, dispatchers, repeatIndex }, passData))));
    },
});
exports.default = (0, react_redux_1.connect)(mapState, mapDispatch)(DynamicButton);
//# sourceMappingURL=DynamicButton.js.map